import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=04e6dfb5&scoped=true&"
import script from "./Show.vue?vue&type=script&lang=js&"
export * from "./Show.vue?vue&type=script&lang=js&"
import style0 from "./Show.vue?vue&type=style&index=0&id=04e6dfb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e6dfb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e6dfb5')) {
      api.createRecord('04e6dfb5', component.options)
    } else {
      api.reload('04e6dfb5', component.options)
    }
    module.hot.accept("./Show.vue?vue&type=template&id=04e6dfb5&scoped=true&", function () {
      api.rerender('04e6dfb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/externalPurchases/Show.vue"
export default component.exports